/** Level 3 timed mock forms — mixed item sets + constructed response. */

export const L3_MOCK_FORM_COUNT = 4;
/** One complimentary L3 Mock 1 per account (separate from L1/L2 free mocks). */
export const L3_FREE_MOCK_FORM = 1;

export const L3_MOCK_FORMS = Array.from({ length: L3_MOCK_FORM_COUNT }, (_, i) => {
  const id = i + 1;
  return {
    id,
    slug: `session-${id}`,
    label: `Mock ${id}`,
    shortLabel: `Session ${id}`,
    href: `/quiz/l3/session-${id}`,
    free: id === L3_FREE_MOCK_FORM,
    blurb:
      id === 1
        ? '132-min mixed session · 5 item + 6 constructed-response · free once'
        : id % 2 === 0
          ? '132-min mixed session · 6 item + 5 constructed-response · alternate Institute mix'
          : '132-min mixed session · 5 item + 6 constructed-response · pathway coverage',
  };
});

export function parseL3MockFormId(slug = '') {
  const s = String(slug || '').toLowerCase();
  if (s === 'session' || s === 'all' || s === 'mock') return null;
  // Bounded by L3_MOCK_FORM_COUNT (CFA-63) — not a literal range, not any number.
  const m = /^session-(\d+)$/.exec(s);
  if (!m || Number(m[1]) < 1 || Number(m[1]) > L3_MOCK_FORM_COUNT) return null;
  return Number(m[1]);
}

export function l3MockFormById(id) {
  return L3_MOCK_FORMS.find((f) => f.id === Number(id)) || null;
}
